import React from 'react';

import QuestionHOC from './QuestionHOC';

export default function PreferredLanguage({ index, item }) {
  const displayQuestion = () => {
    if (item.hasOwnProperty('onlyAnswer') && item.onlyAnswer === true) {
      return <div className="col">English</div>
    } else {
      return <>
        <div className="col-8">Preferred Language</div>
        <div className="col-4">English</div>
      </>
    }
  }

  return <QuestionHOC item={item} index={index}>
    <div className="row">
      {displayQuestion()}
    </div>
  </QuestionHOC>
}